import { FC, useCallback, useEffect, useState } from "react";
import styled from "@emotion/styled";
import popupActivityService from "src/module/popupActivity/service";
import { IndexPopupEntity } from "../../../module/indexPopup/entity/indexPopupEntity";
import { Button, Col, DatePicker, Form, Input, Row, Select, Table } from "antd";
import { useTranslation } from "react-i18next";
import FormItem from "antd/es/form/FormItem";

export const PopupRecord: FC = () => {
	const { t } = useTranslation();
	const [searchObj, setSearchObj] = useState({
		customPageNum: 1,
		customPageSize: 15,
	});
	const [formRef] = Form.useForm();

	const [total, setTotal] = useState(0);

	const offerOrGroupOption = [1, 2, 3].map((num) => {
		return { label: num, value: num };
	});

	const customerTypeOptions = [
		{
			label: "会员客户",
			value: 1,
		},
		{
			label: "非会员客户",
			value: 2,
		},
	];
	const popupTypeOptions = [
		{
			label: "优惠券",
			value: 1,
		},
		{
			label: "会员卡",
			value: 2,
		},
		{
			label: "问候语",
			value: 3,
		},
	];
	// 1执行中 2已领取/已成交 3未成交 4已过期
	const statusOptions = [
		{
			label: "执行中",
			value: 1,
		},
		{
			label: "已领取/已成交",
			value: 2,
		},
		{
			label: "未成交",
			value: 3,
		},
		{
			label: "已过期",
			value: 4,
		},
	];

	const getLabelFromOptions = (options: any[], value: number) => {
		const item = options.find((item) => item.value === value);
		return item?.label || "";
	};

	const [dataList, setDataList] = useState<IndexPopupEntity[]>([]);
	const columns = [
		{
			title: "id",
			dataIndex: "id",
		},
		{
			title: "昵称/手机号",
			render: (record: any) => {
				return record.nickName + "/" + record.mobile;
			},
		},
		{
			title: "客户类型",
			render: (record: any) => {
				return getLabelFromOptions(customerTypeOptions, record.type);
			},
		},
		{
			title: "弹窗类型",
			render: (record: any) => {
				return getLabelFromOptions(popupTypeOptions, record.popupType);
			},
		},
		{
			title: "状态",
			render: (record: any) => {
				return getLabelFromOptions(statusOptions, record.status);
			},
		},
		{
			title: "弹窗次数",
			dataIndex: "times",
		},
		{
			title: t("createdTime"),
			dataIndex: "createdAt",
		},
		{
			title: "过期时间",
			dataIndex: "expiredAt",
		},
		{
			title: "Group",
			dataIndex: "rfmGroup",
		},
		{
			title: "offer",
			dataIndex: "offer",
		},
	];

	const init = useCallback(async () => {
		const { data } = await popupActivityService.record(searchObj);
		setDataList(data.data.list);
		setTotal(data.data.total);
	}, [searchObj]);

	useEffect(() => {
		init();
	}, [init]);

	const onReset = () => {
		formRef.resetFields();
	};

	const onSearch = () => {
		const duration = formRef.getFieldValue("activityDuration");
		const isHasDuration = duration?.length === 2;
		const [startDate, endDate] = duration || [];
		const finalDate = isHasDuration
			? {
					createdStartAt: startDate.format("YYYY-MM-DD 00:00:00"),
					createdEndAt: endDate.format("YYYY-MM-DD 23:59:59"),
			  }
			: {
					createdStartAt: void 0,
					createdEndAt: void 0,
			  };

		setSearchObj(
			JSON.parse(
				JSON.stringify({
					...searchObj,
					...formRef.getFieldsValue(),
					...finalDate,
					activityDuration: void 0,
				})
			)
		);
	};

	return (
		<Container>
			<Form form={formRef} labelCol={{ span: 4 }} labelAlign='left' wrapperCol={{ span: 16 }}>
				<Row gutter={[10, 10]}>
					<Col span={8}>
						<FormItem label='昵称' name='nickname'>
							<Input placeholder='请输入昵称' />
						</FormItem>
					</Col>
					<Col span={8}>
						<FormItem label='手机号' name='mobile'>
							<Input placeholder='请输入手机号' />
						</FormItem>
					</Col>
					<Col span={8}>
						<FormItem label='客户类型' name='type'>
							<Select options={customerTypeOptions} placeholder='请选择客户类型' />
						</FormItem>
					</Col>
				</Row>
				<Row gutter={[10, 10]}>
					<Col span={8}>
						<FormItem label='状态' name='status'>
							<Select options={statusOptions} placeholder='请选择状态' />
						</FormItem>
					</Col>
					<Col span={8}>
						<FormItem label='Group' name='group'>
							<Select options={offerOrGroupOption} placeholder='请选择Group' />
						</FormItem>
					</Col>
					<Col span={8}>
						<FormItem label='Offer' name='offer'>
							<Select options={offerOrGroupOption} placeholder='请选择Offer' />
						</FormItem>
					</Col>
				</Row>
				<Row gutter={[10, 10]}>
					<Col span={8}>
						<FormItem label='活动时间' name='activityDuration'>
							<DatePicker.RangePicker />
						</FormItem>
					</Col>
					{/* <Col span={8}>
						<FormItem label='过期时间' name='expiredAt'>
							<DatePicker />
						</FormItem>
					</Col> */}
					<Col span={8}>
						<FormItem label='弹窗类型' name='popupType'>
							<Select options={popupTypeOptions} placeholder='请选择弹窗类型' />
						</FormItem>
					</Col>
					<Col span={8} className='actionCol'>
						<FormItem>
							<Button className='resetBtn' onClick={onReset}>
								重置
							</Button>
							<Button type='primary' onClick={onSearch}>
								查询
							</Button>
						</FormItem>
					</Col>
				</Row>
			</Form>
			<Table
				columns={columns}
				dataSource={dataList}
				rowKey={(record) => record.id + ""}
				style={{ marginTop: 20 }}
				pagination={{
					pageSize: searchObj.customPageSize,
					current: searchObj.customPageNum,
					total: total,
					showTotal: () => {
						return (
							<div>
								{t("total")} {total}条
							</div>
						);
					},
				}}
				onChange={(pagination) => {
					setSearchObj({
						...searchObj,
						customPageNum: pagination.current ?? 1,
						customPageSize: pagination.pageSize ?? 15,
					});
				}}
			/>
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	padding: 20px;
	.ant-picker {
		width: 100%;
	}
	.actionCol {
		.resetBtn {
			margin-right: 10px;
		}
	}
`;
